module.exports = __webpack_public_path__ + "img/Flag_of_Nepal.f018c4c4.svg";